import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import VueRouter from 'vue-router'
import store from './store'
import moment from 'moment'
import Loading from 'vue-loading-overlay'
import {ClientTable} from 'vue-tables-2'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import CircularCountDownTimer from "vue-circular-count-down-timer";
// import jquery from 'jquery'
import '@progress/kendo-ui' // This will import the entire Kendo UI library
// As an alternative, you could import only the scripts that are used by a specific widget:
// import '@progress/kendo-ui/js/kendo.grid' // Imports only the Grid script and its dependencies
import '@progress/kendo-ui/js/cultures/kendo.culture.en-GB.js'
import { Grid, GridColumn, GridInstaller } from '@progress/kendo-grid-vue-wrapper';
import { DataSourceInstaller } from '@progress/kendo-datasource-vue-wrapper';
import { Button, ButtonsInstaller } from '@progress/kendo-buttons-vue-wrapper';
//import { Chart, ChartSeriesItem, SotckChart, Sparkline, SparklineSeriesItem, ChartInstaller } from '@progress/kendo-charts-vue-wrapper';
import JSZip from 'jszip';
//import $ from 'jquery';
import '@progress/kendo-theme-default/dist/all.css'
import { AlertPlugin } from 'bootstrap-vue'
Vue.use(AlertPlugin)
//Vue.use(ChartInstaller);
//kendo.culture("en-GB");
window.JSZip = JSZip;
//Vue.use(DateinputsInstaller);
Vue.use(ButtonsInstaller);
Vue.use(Button);
Vue.use(GridInstaller)
Vue.use(Grid)
Vue.use(GridColumn)
Vue.use(DataSourceInstaller);



Vue.use(CircularCountDownTimer);
Vue.use(Vuex);
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(require('vue-moment'))
Vue.use(Loading)
Vue.use(ClientTable)

import router from './router'
Vue.use(VueRouter);

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

//window.JQuery = require('jquery')
Vue.config.productionTip = false

new Vue({
	router,
	store,
	moment,
  render: h => h(App),
}).$mount('#app')
